import clsx from 'clsx'
import {Dispatch, FC, SetStateAction, useState} from 'react'
import {SelectCustomer} from './SelectCustomer'
import {AddCustomer} from './AddCustomer'
import {SearchSelectOption} from '../../../../../../../_metronic/helpers/components/SearchSelect'
import {FieldHelpLabel} from '../../../../../../../_metronic/helpers/components/FieldHelp'
import {optionalBuyerHint} from '../../core/invoiceBuyerRequirement'

type props = {
  step: {
    step: number
    setStep: Dispatch<SetStateAction<number>>
  }
  buyerSelected: {
    buyerSelected: SearchSelectOption | undefined
    setBuyerSelected: Dispatch<SetStateAction<SearchSelectOption | undefined>>
  }
  isBuyerRequired: boolean
  invoiceTemplate: number
}

const InvoiceSimpleFormCustomer: FC<props> = ({
  step,
  buyerSelected,
  isBuyerRequired,
  invoiceTemplate,
}) => {
  const [tab, setTab] = useState(0)
  return (
    <>
      {!isBuyerRequired && (
        <div className='alert alert-light-info mb-5'>{optionalBuyerHint(invoiceTemplate)}</div>
      )}
      <div className='fw-bold fs-6 mb-2'>
        <FieldHelpLabel label='نوع خریدار' helpKey='header.tob' />
      </div>
      <div className='btn-group w-100 p-0' role='group'>
        <button
          type='button'
          className={clsx('btn btn-light-primary', {active: tab == 0})}
          onClick={() => {
            setTab(0)
          }}
        >
          <span className={clsx({'fw-bolder': tab == 0})}>خریدار حقیقی</span>
        </button>
        <button
          type='button'
          className={clsx('btn btn-light-primary', {active: tab == 1})}
          onClick={() => {
            setTab(1)
          }}
        >
          <span className={clsx({'fw-bolder': tab == 1})}>خریدار حقوقی</span>
        </button>
        <button
          type='button'
          className={clsx('btn btn-light-primary', {active: tab == 2})}
          onClick={() => {
            setTab(2)
          }}
        >
          <span className={clsx({'fw-bolder': tab == 2})}>خریدار جدید</span>
        </button>
      </div>
      <div className='card mt-7 pt-5'>
        {tab == 0 && <SelectCustomer basemode={1} buyerSelected={buyerSelected} step={step} />}
        {tab == 1 && <SelectCustomer basemode={2} buyerSelected={buyerSelected} step={step} />}
        {tab == 2 && <AddCustomer buyerSelected={buyerSelected} step={step} />}
      </div>
    </>
  )
}

export {InvoiceSimpleFormCustomer}
